export function canVerifyPermissions(dumpsysPackage: string): boolean {
  return dumpsysPackage.includes("granted=");
}

export function ungrantedPermissions(dumpsysPackage: string, permissions: string[]): string[] {
  return permissions.filter(
    (permission) =>
      !new RegExp(`${permission.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}:\\s*granted=true`).test(
        dumpsysPackage,
      ),
  );
}
